// extracted by mini-css-extract-plugin
export default {"tagCard":"Tags_tagCard__ALJCi","tags":"Tags_tags__7t6Sr","active":"Tags_active__HAX9v"};